module.exports = __webpack_public_path__ + "static/media/experts_amber.f22edc96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/experts_amber.svg
// module id = 1092
// module chunks = 2